import React from 'react'
import { useStyles } from './style'
import { Avatar, Button, Checkbox } from '@mui/material'
import { AiOutlineClockCircle } from 'react-icons/ai'
import { formatDate, formatDateTime, priceFormatLocal } from 'utils/helper'
import { RiFileList3Line } from 'react-icons/ri'

const DeliveryOrderItem = props => {
  const { order } = props
  const styles = useStyles()
  const isOrderExpanded = props.expandedList.includes(props.idx)

  const total =
    order.order_delivery_item[0].order_delivery_item.quantity *
    order.order_delivery_item[0].order_item.price

  const date =
    order.status === 'COMPLETED' ? order?.received_at ?? order.created_at : order.created_at

  return (
    <div key={order.id} className={styles.boxItem}>
      <div className={styles.headerInfo}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {props.status === 'WAITING APPROVAL HOD' && props.userData?.role === 'hod' && (
            <>
              <Checkbox
                className={styles.checkboxCustom}
                style={{ padding: 0, marginRight: 8 }}
                checked={props.selectedOrder.includes(order.id)}
                onChange={() => props.setSelectedOrder(order.id)}
              />
              <p className={styles.checkboxLabel}>Waiting Approval</p>
              <p className={styles.garing}>/</p>
            </>
          )}
          <p
            className={styles.headerText}
            style={{ color: '#ff3a59', cursor: 'pointer' }}
            onClick={() => props.showDetail(order)}
          >
            {order.order_delivery_number}
          </p>
          <p className={styles.garing}>/</p>
          <Avatar
            src={
              order.order_delivery_item[0].order_data.customer.profile_picture
                ? process.env.REACT_APP_FILE_BASE_URL +
                  '/' +
                  order.order_delivery_item[0].order_data.customer.profile_picture
                : null
            }
            style={{ marginRight: 10, width: 24, height: 24 }}
          />
          <p className={styles.headerText}>
            {order.order_delivery_item[0].order_data.customer.name}
          </p>
          <p className={styles.garing}>/</p>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <AiOutlineClockCircle />
            <p style={{ fontSize: 14 }}>{formatDateTime(date)}</p>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'baseline' }}>
          <p style={{ fontWeight: 'bold', fontSize: 14 }}>Total</p>
          <p style={{ fontWeight: 'bold' }}>{priceFormatLocal(total)}</p>
        </div>
      </div>
      <div className={styles.bodyContent}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, width: '60%' }}>
          <img
            className={styles.imageProduct}
            src={
              order.order_delivery_item[0].order_item.product.media
                ? process.env.REACT_APP_FILE_BASE_URL +
                  '/' +
                  order.order_delivery_item[0].order_item.product.media[0]
                : '/assets/images/dummy.png'
            }
          />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <h5 style={{ fontSize: 16 }}>{order.order_delivery_item[0].order_item.name}</h5>
            <p style={{ fontSize: 13, color: '#666' }}>
              <span style={{ width: 140, display: 'inline-block' }}>Material ID</span>
              :&nbsp;&nbsp;&nbsp;{order.order_delivery_item[0].order_item.product.sku}
            </p>
            {order.order_delivery_item[0].general_ledger_accounts && (
              <p style={{ fontSize: 13, color: '#666' }}>
                <span style={{ width: 140, display: 'inline-block' }}>G/L Account</span>
                :&nbsp;&nbsp;&nbsp;
                {order.order_delivery_item[0].general_ledger_accounts
                  .map(gla => gla.general_ledger_account.name)
                  .join(', ')}
              </p>
            )}
            {order.order_delivery_item[0].order_item.po_reason && (
              <p style={{ fontSize: 13, color: '#666' }}>
                <span style={{ width: 140, display: 'inline-block' }}>PO Reason</span>
                :&nbsp;&nbsp;&nbsp;{order.order_delivery_item[0].order_item.po_reason}
              </p>
            )}
            {order.order_delivery_item[0].order_item.note && (
              <p style={{ fontSize: 13, color: '#666' }}>
                <span style={{ width: 140, display: 'inline-block' }}>Notes</span>
                :&nbsp;&nbsp;&nbsp;{order.order_delivery_item[0].order_item.note}
              </p>
            )}
            {order.order_delivery_item[0].order_item.expect_date && (
              <p style={{ fontSize: 13, color: '#666' }}>
                <span style={{ width: 140, display: 'inline-block' }}>Expect Delivery Date</span>
                :&nbsp;&nbsp;&nbsp;{formatDate(order.order_delivery_item[0].order_item.expect_date)}
              </p>
            )}
          </div>
        </div>
        <div style={{ width: '20%', textAlign: 'right' }}>
          <p>
            {order.order_delivery_item[0].order_delivery_item.quantity} x{' '}
            {priceFormatLocal(order.order_delivery_item[0].order_item.price)}
          </p>
        </div>
      </div>
      <div
        className={styles.restItem}
        style={{
          height: isOrderExpanded ? '100%' : '0',
          visibility: isOrderExpanded ? 'visible' : 'hidden'
        }}
      >
        {order.order_delivery_item?.slice(1).map(item => (
          <React.Fragment key={item.order_item?.id}>
            <div className={styles.bodyContent}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, width: '60%' }}>
                <img
                  className={styles.imageProduct}
                  src={
                    item.order_item.product.media
                      ? process.env.REACT_APP_FILE_BASE_URL + '/' + item.order_item.product.media[0]
                      : '/assets/images/dummy.png'
                  }
                />
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <h5 style={{ fontSize: 16 }}>{item.order_item.name}</h5>
                  <p style={{ fontSize: 13, color: '#666' }}>
                    <span style={{ width: 140, display: 'inline-block' }}>Material ID</span>
                    :&nbsp;&nbsp;&nbsp;{item.order_item.product.sku}
                  </p>
                  {item.general_ledger_accounts && (
                    <p style={{ fontSize: 13, color: '#666' }}>
                      <span style={{ width: 140, display: 'inline-block' }}>G/L Account</span>
                      :&nbsp;&nbsp;&nbsp;
                      {item.general_ledger_accounts
                        .map(gla => gla.general_ledger_account.name)
                        .join(', ')}
                    </p>
                  )}
                  {item.order_item.po_reason && (
                    <p style={{ fontSize: 13, color: '#666' }}>
                      <span style={{ width: 140, display: 'inline-block' }}>PO Reason</span>
                      :&nbsp;&nbsp;&nbsp;{item.order_item.po_reason}
                    </p>
                  )}
                  {item.order_item.note && (
                    <p style={{ fontSize: 13, color: '#666' }}>
                      <span style={{ width: 140, display: 'inline-block' }}>Notes</span>
                      :&nbsp;&nbsp;&nbsp;{item.order_item.note}
                    </p>
                  )}
                  {item.order_item.expect_date && (
                    <p style={{ fontSize: 13, color: '#666' }}>
                      <span style={{ width: 140, display: 'inline-block' }}>
                        Expect Delivery Date
                      </span>
                      :&nbsp;&nbsp;&nbsp;{formatDate(item.order_item.expect_date)}
                    </p>
                  )}
                </div>
              </div>
              <div style={{ width: '20%', textAlign: 'right' }}>
                <p>
                  {item.order_delivery_item.quantity} x {priceFormatLocal(item.order_item.price)}
                </p>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
      {order.order_delivery_item?.length > 1 && (
        <div style={{ padding: '0 20px 10px 20px' }}>
          <Button
            style={{ textTransform: 'capitalize' }}
            onClick={() => props.toggleExpand(props.idx, isOrderExpanded)}
          >
            Show {isOrderExpanded ? 'Less' : 'More'}
          </Button>
        </div>
      )}
      <div className={styles.footerContent}>
        <button className={styles.footerButton} onClick={() => props.showDetail(order)}>
          <RiFileList3Line fontSize={18} />
          Detail Delivery
        </button>
      </div>
    </div>
  )
}

export default DeliveryOrderItem
